module.exports = __webpack_public_path__ + "img/header-item-5.c854627c.png";